import Immutable from 'immutable';

import { createStore, getActionIds } from '../helpers/redux';
import { AccountActions } from '../actions/account';
import { ProjectActions } from '../actions/project';

const actions = getActionIds(AccountActions);
const projectActions = getActionIds(ProjectActions);

const initialState = Immutable.fromJS({
  pendingAccountUsers: {},
});

export const pendingAccountUsersSelector = (state) =>
  state.pendingAccountUsers.get('pendingAccountUsers');

export const pendingAccountUsers = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [actions.getAccountUsers.success]: (state, action) =>
    state.mergeDeep({
      pendingAccountUsers: action.result.entities.pendingAccountUsers,
    }),

  [actions.addUser.success]: (state, action) =>
    ((action.result.entities.pendingAccountUsers) ? state.mergeDeep({
      pendingAccountUsers: action.result.entities.pendingAccountUsers,
    }) : state),

  [actions.removePendingUser.success]: (state, action) =>
    state.deleteIn(['pendingAccountUsers', action.result.userId]),
});



// WEBPACK FOOTER //
// ./src/reducers/pendingAccountUsers.js